export interface PaletteInterface {
  main: {
    primary: string
    secondary: string
    tertiary: string
    quaternary: string
  }
  neutral: {
    black: string
    medium: string
    light: string
    white: string
  }
  hover: {
    primary: string
    medium: string
    success: string
    light: string
  }
  support: {
    success: string
    warning: string
    error: string
  }
}

export const palette: PaletteInterface = {
  main: {
    primary: '#2770e5',
    secondary: '#e5253d',
    tertiary: '#f88795',
    quaternary: '#f3f6fb'
  },
  neutral: {
    black: '#000000',
    medium: '#4d4d4d',
    light: '#9d9d9d',
    white: '#ffffff'
  },
  hover: {
    primary: '#1b4ea0',
    medium: '#353535',
    success: '#077117',
    light: '#f5f5f5'
  },
  support: {
    success: '#2cac40',
    warning: '#e58221',
    error: '#a0192a'
  }
}
